import { escapeRegExp } from 'lodash';
export const getSearchRegex = searchText => new RegExp(escapeRegExp(searchText), 'i');
